import { TransportMessage, TransportMessageDetails } from './message-administration.model';
import { Identity } from '@sdbn/common';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';

@Injectable({
  providedIn: 'root'
})
export class MessageAdministrationService  {

  constructor(private appServerAPI: AppServerAPI) { }

  public getTransportMessages(): Observable<TransportMessage[]> {
    return this.appServerAPI.execute<TransportMessage[]>('/client/admin/message', {});
  }

  public getTransportMessageDetails(identity: Identity): Observable<TransportMessageDetails> {
    return this.appServerAPI.execute<TransportMessageDetails>('/client/admin/message/details', identity);
  }

  public saveTransportMessage(details: TransportMessageDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/message/save', details);
  }

  public deleteTransportMessage(identity: Identity): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/message/delete', identity);
  }

  public sendTransportMessage(identity: Identity): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/message/send', identity);
  }
}
